'use client';
export default {
    alerts: [],
    processedAlerts: [],
    errors: []
};
